import { render } from "./Integration.vue?vue&type=template&id=59a4aa31&ts=true"
import script from "./Integration.vue?vue&type=script&lang=ts"
export * from "./Integration.vue?vue&type=script&lang=ts"

import "./Integration.vue?vue&type=style&index=0&id=59a4aa31&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__